
    import { computed, defineComponent, nextTick, onMounted, ref } from 'vue'

    import { VulgarNicknameError } from '@/app/errors/vulgar-nickname-error'
    import { useChatStore } from '@/app/stores/chat'

    import { useSweetAlert } from '@/common/composables/sweet-alert'
    import { useI18n } from 'vue-i18n-composable'

    export default defineComponent({
        emits: [
            'message-sent'
        ],
        setup (props, { emit }) {
            const i18n = useI18n()
            const chatStore = useChatStore()
            const { showToast } = useSweetAlert()

            const authorField = ref<HTMLInputElement>()
            const editMode = ref(true)
            const messageField = ref<HTMLInputElement>()

            const message = computed((): string => chatStore.message)
            const setMessage = (value: string): void => {
                chatStore.message = value
            }

            const nickname = computed((): string => chatStore.nickname)
            const setNickname = (value: string): void => {
                try {
                    chatStore.nickname = value
                } catch (e) {
                    if (e instanceof VulgarNicknameError) {
                        showToast(
                            i18n.t('chat.errors.vulgar-nick').toString(),
                            'warning'
                        )
                    }

                    throw e
                }
            }

            const acceptNickname = (): void => {
                if (nickname.value !== '') {
                    editMode.value = false
                    messageField.value?.focus()
                }
            }

            const editNickname = (): void => {
                editMode.value = true
                nextTick((): void => {
                    authorField.value?.focus()
                })
            }

            const sendMessage = (): void => emit('message-sent')

            onMounted((): void => {
                if (nickname.value !== '') {
                    editMode.value = false
                }
            })

            return {
                authorField,
                messageField,
                editMode,

                nickname,
                acceptNickname,
                editNickname,
                setNickname,

                message,
                setMessage,
                sendMessage
            }
        }
    })
